import react, { useEffect } from 'react';
import OpenTransactionsView from './OpenTransactionsView';
import { useDispatch, useSelector } from 'react-redux';
import {
  getTransactionPaymentLink,
  getTransactions,
  getUser,
  LocalizePropType,
  selectUser,
  selectUserTransactions,
  withTextLocalizer,
} from 'getaway-data-layer';

type Props = {
  localize: LocalizePropType;
};

const OpenTransactionsContainer = ({ localize }: Props) => {
  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const transactions = useSelector(selectUserTransactions);
  const openTransactions =
    transactions?.transactions?.filter(
      (transaction) => transaction.status === 'open'
    ) || [];

  const onClickPayOpenInvoice = (transactionId: number) => {
    const newWindow = window.open('', '_blank');
    dispatch(
      getTransactionPaymentLink(transactionId, (payByLinkData) => {
        if (payByLinkData?.url) {
          newWindow.location.href = payByLinkData?.url;
        }
      })
    );
  };

  const onClickOpenInvoice = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  useEffect(() => {
    dispatch(getTransactions());
  }, []);

  return (
    <OpenTransactionsView
      localize={localize}
      user={user}
      openTransactions={openTransactions}
      onClickPayOpenInvoice={onClickPayOpenInvoice}
      onClickOpenInvoice={onClickOpenInvoice}
    />
  );
};

export default withTextLocalizer(OpenTransactionsContainer);
